import { ComponentProps, PropsWithChildren, ReactElement } from "react";
import { TreeRoot } from "./Tree.styled";

type TreeProps = ComponentProps<"ul">;

function Tree({
  children,
  ...attributes
}: PropsWithChildren<TreeProps>): ReactElement<HTMLUListElement> {
  return <TreeRoot {...attributes}>{children}</TreeRoot>;
}

export { Tree };
